import { ICommonLink } from '@src/models/common';

export const HELP: ICommonLink = {
  href: '/faq',
  name: 'Centra Help',
  id: 'helpLink',
  disableNextJs: true,
};

export const WIKI: ICommonLink = {
  href: '/wiki',
  name: 'Centra AdHub',
  id: 'wikiLink',
  target: '_blank',
  disableNextJs: true,
};

export const MEDIA: ICommonLink = {
  href: '/media',
  name: 'Centra Media',
  id: 'mediaLink',
  target: '_blank',
  disableNextJs: true,
};
